import React, { PureComponent } from 'react'
import MyDriveComponent from '../../components/My Drive/index'

import './MyDrive.css'

class MyDrive extends PureComponent {
  render() {
    return <MyDriveComponent />
  }
}

export default MyDrive
